import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUserState } from "./app/selector";

// We reuse the same mobile-friendly loader so the transition looks seamless
const FullScreenLoader = () => (
    <div
        className="d-flex flex-column justify-content-center align-items-center bg-light w-100 px-3"
        style={{ minHeight: "100vh" }}
    >

        <h5 className="mt-4 text-muted text-center">Securing your session...</h5>
    </div>
);

const ProtectedRoute = () => {
    const { loggedIn, isCheckingAuth } = useSelector(getUserState);

    // 1. If we are still checking the token, show the loader.
    if (isCheckingAuth) {
        return <FullScreenLoader />;
    }

    // 2. If checking is done and user is NOT logged in, redirect to Layout (root "/")
    if (!loggedIn) {
        return <Navigate to="/" replace />;
    }

    // 3. If logged in, render the requested route normally
    return <Outlet />;
};

export default ProtectedRoute;